import { useAppStore } from "@/stores/appStore";
import { createFileRoute } from "@tanstack/react-router";
import styled from "styled-components";
import { type_c, type_a, type_d } from "@/theme/typography";
import { useContent } from "@/hooks/useContent";
import Input from "@/components/primitives/Input/Input";
import { Modifiers } from "@/components/ui/Modifiers/Modifiers";

export const Route = createFileRoute("/_configurator/step-3")({
	component: Step3,
});

function Step3() {
	const { pillar } = useAppStore((state) => state.configurator);
	const { getPillars, getModifiers } = useContent();
	const currentPillar = getPillars().find((x) => x.id === pillar.id);

	const pillarModifiers = getModifiers().filter((modifier) =>
		pillar.selectedModifiers.some((selected) => selected.id === modifier.id)
	);

	return (
		<Wrapper>
			<p className="step__number" style={type_c}>
				Step 3
			</p>
			<h4 className="step__title" style={type_a}>
				Pillars
			</h4>
			<div className="section_wrapper">
				<Section>
					<p className="step__subtitle" style={type_d}>
						Dimension
					</p>
					<Container>
						{currentPillar &&
							currentPillar.dimensions.map((dimension, index) =>
								dimension.selectType === "range" ? (
									<Input
										key={index}
										title={dimension.title}
										minVal={dimension.minVal}
										maxVal={dimension.maxVal}
										defaultVal={dimension.defaultVal}
										step={dimension.step}
										id={dimension.id}
										stateType={"selectedDimensions"}
										stateKey={"pillar"}
									/>
								) : null
							)}
					</Container>
				</Section>

				{currentPillar?.modifiers.length ? (
					<Section>
						<p className="step__subtitle" style={type_d}>
							Options
						</p>
						<Modifiers
							modifiersArray={currentPillar?.modifiers || []}
							stateKey={"pillar"}
							stateType={"selectedModifiers"}
							defaultVal={pillar.selectedModifiers}
						/>
					</Section>
				) : null}

				{pillarModifiers &&
					pillarModifiers.map(
						(modifier) =>
							modifier.dimensions &&
							modifier.dimensions.map((dimension, index) => (
								<Section key={`${modifier.id}-${index}`}>
									<p className="step__subtitle" style={type_d}>
										Dimension
									</p>
									<Container>
										<Input
											key={index}
											title={dimension.title}
											minVal={dimension.minVal}
											maxVal={dimension.maxVal}
											defaultVal={pillar.selectedDimensions[dimension.id]}
											step={dimension.step}
											id={dimension.id}
											stateType="selectedDimensions"
											stateKey="pillar"
										/>
									</Container>
								</Section>
							))
					)}
			</div>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	padding-block: 1rem;
	padding-inline: 10px;
	height: 100%;

	.section_wrapper {
		overflow: scroll;
		padding-bottom: 80px;
		height: 100%;
		padding-block-start: 0.5rem;
	}

	& > :last-child {
		margin-bottom: 0;
	}

	.step__number {
		color: #7d6a64;
	}

	.step__title {
		padding-block-end: 0.5rem;
		color: ${({ theme }) => theme.colors.secondary};
		border-bottom: 1px solid #e7dad7;
	}

	.step__subtitle {
		margin-bottom: 0.3rem;
		font-weight: 400;
		color: #7d6a64;
		margin-bottom: 1rem;
	}
`;

const Section = styled.section`
	margin-bottom: 1rem;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 1rem;
	background: #e9e1de;
	padding-inline: 16px;
	padding-block: 1rem;
	border-radius: 5px;

	& > *:not(:last-child) {
		padding-block-end: 1rem;
		border-bottom: 1px solid #d8cecb;
	}
`;
